<template>
  <div class="whatsapp-share-page">
    <div class="preview-wrapper">
      <WhatsAppStatusPreview
        :media="imgUrl"
        :text="text"
        :media-type="mediaType"
        fill-height
      />
    </div>
    <div class="actions">
      <v-btn
        color="success"
        size="large"
        block
        :loading="isSharing"
        :disabled="!isWebShareSupported || (!text && !imgUrl)"
        @click="handleShare"
      >
        <v-icon
          class="mr-2"
          size="20"
        >
          mdi-whatsapp
        </v-icon>
        {{ t('content-creator.whatsapp.mobile.share-button') }}
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { showSnackbarMessage } from '@/lib/snackbarMessages'
import { useWhatsAppShare } from '@/modules/contentCreator/creator/WhatsApp/useWhatsAppShare'
import WhatsAppStatusPreview from '@/modules/contentCreator/creator/WhatsApp/WhatsAppStatusPreview.vue'

const route = useRoute()
const { t } = useI18n()

const text = (route.query.text as string) ?? ''
const imgUrl = (route.query.imgUrl as string) ?? ''
const mediaType = (route.query.mediaType as string) ?? ''

const { isSharing, shareNative } = useWhatsAppShare()

const isWebShareSupported = computed(() => !!navigator?.share)

async function handleShare() {
  try {
    await shareNative(text, imgUrl, mediaType)
  } catch (err: unknown) {
    if (err instanceof Error) {
      if (err.name === 'AbortError') {
        // User cancelled sharing
        return
      }
      if (err.name === 'NotSupportedError') {
        showSnackbarMessage('error', t('content-creator.whatsapp.mobile.web-share-not-supported'))
      } else {
        showSnackbarMessage('error', t('alerts.content-creator.general.error'))
      }
    }
  }
}
</script>

<style scoped>
.whatsapp-share-page {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  padding: 16px;
  background: #1a1a1a;
  z-index: 100000;
  position: relative;
}

.preview-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 0;
}

.actions {
  padding: 16px 0 max(32px, env(safe-area-inset-bottom));
  flex-shrink: 0;
}

.w-100 {
  width: 100%;
}
</style>
